import React from 'react'

export default function StrikeoutGroup({ rect }) {
  const [[x1, y1], [x2, y2], [x3, y3], [x4, y4]] = rect

  if (x3 || x4 || y2 || y4) {
    // be quiet, eslint
  }

  return <line x1={x1} y1={(y1 + y3) / 2} x2={x2} y2={(y2 + y4) / 2} />
}
